import { Component, h, Prop } from '@stencil/core';

@Component({
    tag: 'rentware-list-articles-template-skeleton',
    styleUrl: 'style.sass',
    shadow: false,
})
export class RentwareListArticlesTemplateSkeleton {
    @Prop() tabs;

    render() {
        return (
            <div class="ArticlesContainer">
                <div class="ArticlesContentContainer NoScroll">
                    <div class="ArticlesContent">
                        <rentware-tabs-skeleton tabs={this.tabs} />

                        <rentware-spacer size="M" />

                        <rtr-short-article-list-skeleton />
                        <rtr-short-article-list-skeleton />
                        <rtr-short-article-list-skeleton />
                        <rtr-short-article-list-skeleton />
                        <rtr-short-article-list-skeleton />
                        <rtr-short-article-list-skeleton />
                    </div >
                </div >
            </div >
        )
    }
}
